import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lock14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M6.25 10V8H7.75V10H6.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 0.25C4.92893 0.25 3.25 1.92893 3.25 4V5.25H2.41667C1.73827 5.25 1.25 5.81657 1.25 6.4375V12.5625C1.25 13.1834 1.73827 13.75 2.41667 13.75H11.5833C12.2617 13.75 12.75 13.1834 12.75 12.5625V6.4375C12.75 5.81657 12.2617 5.25 11.5833 5.25H10.75V4C10.75 1.92893 9.07107 0.25 7 0.25ZM9.25 5.25V4C9.25 2.75736 8.24264 1.75 7 1.75C5.75736 1.75 4.75 2.75736 4.75 4V5.25H9.25ZM2.75 6.75V12.25H11.25V6.75H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Lock14.displayName = 'Lock14';
export default Lock14;
